import {
  faBook,
  faBookMedical,
  faBuilding,
  faBullseye,
  faCircleQuestion,
  faClipboardList,
  faDashboard,
  faFeather,
  faFileInvoiceDollar,
  faPerson,
  faProcedures,
  faReplyAll,
  faSliders,
  faStamp,
  faSubscript,
  faUsers,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import IRouter from "../interfaces/IRouter";
import Dashboard from "../view/private/Dashboard/Dashboard";
import Exam from "../view/private/Exam/Exam";
import SelectedExam from "../view/private/Exam/SelectedExam/SelectedExam";
import LogsIndex from "../view/private/Logs/Logs.index";
import LiveExam from "../view/private/LiveExam/LiveExam.index";
import AddQuestion from "../view/private/Questions/AddQuestion";
import ExamQuestions from "../view/private/Questions/ExamQuestions/ExamQuestions";
import ExamQuestionIndex from "../view/private/Questions/ExamQuestions/ExamQuestions.index";
import Questions from "../view/private/Questions/Question.index";
import QuestionDetails from "../view/private/Questions/QuestionDetails";
import StudentIndex from "../view/private/Students/Students.index";
// import Result from "../view/private/Exam/SelectedExam/Result";
import StudentResult from "../view/private/Exam/SelectedExam/StudentResult";
import ResponsesIndex from "../view/private/Responses/Responses.index";
import Response from "../view/private/Responses/Response/Response";
import ResultIndex from "view/private/Results/Result.index";
import AssignInvigilatorPage from "view/assignInvigilator/AssignInvigilator";
import ViewInvigilatorPage from "view/viewInvigilator/ViewInvigilatorPage";
import AssignStudentsPage from "view/assignStudent/AssignStudentsPage";
import Company from "view/private/company/Company";
import ViewCompany from "view/private/company/ViewCompany";
import EditCompany from "view/private/company/EditCompany";
import PlanList from "view/private/plans/ PlanList";
import EditPlan from "view/private/plans/EditPlan";
import ViewPlan from "view/private/plans/ViewPlan";
import AssignPlan from "view/private/plans/AssignPlan";
import FeatureManagement from "view/private/featuremanagement/FeatureManagement";
import subscriptionList from "view/private/subscriptiion/Subscription";
import ViewSubscription from "view/private/subscriptiion/ViewSubscription";
import EditSubscription from "view/private/subscriptiion/EditSubscription";

export const baseUrl = "/admin-dash";

const adminRoutes: IRouter[] = [
  // {
  //     path: "dashboard",
  //     navbarShow: true,
  //     element: Dashboard,
  //     name: "Dashboard",
  //     icon: faDashboard
  // },
  // {
  //     path: "students",
  //     navbarShow: true,
  //     element: StudentIndex,
  //     name: "Students",
  //     icon: faPerson

  // },
  {
    path: "exam",
    navbarShow: true,
    element: Exam,
    name: "Exam",
    icon: faBook,
  },

  {
    path: "company",
    navbarShow: true,
    element: Company,
    name: "Company",
    icon: faBuilding,
  },

  {
    path: "plan",
    navbarShow:true,
    element: PlanList,
    name: "Plan",
    icon:faClipboardList
  },
  {
    path:"subscription",
    navbarShow: true,
    element:subscriptionList,
    name: "subscription",
    icon: faFileInvoiceDollar

  },
  {
    path:"/admin-dash/subscription/view/:id",
    navbarShow: false,
    element: ViewSubscription,
    name:"view subscription"
  },
  {
    path: "/admin-dash/subscription/edit/:id",
    navbarShow: false,
    element: EditSubscription,
    name: "edit subscription"
  },
  {
    path: "/admin-dash/plan/view/:id",
    navbarShow: false,
    element: ViewPlan,
    name: "view plan"
  },
  {
    path: "assign-plan",
    navbarShow: false,
    element: AssignPlan,
    name: "assign plan"
  },
  {
    path:"plan/edit/:id",
    navbarShow: false,
    element: EditPlan,
    name: "Edit Plan"
    
  },

  {
    path: "feature",
    navbarShow: true,
    element: FeatureManagement,
    name: "Feature Management",
    icon:faSliders
  },

  {
    path: "company/:id",
    navbarShow: false,
    element: ViewCompany,
    name: "View Company",
  },

  {
    path: "company/edit/:id",
    navbarShow: false,
    element: EditCompany,
    name: "Edit Company",
  },
  {
    path: "live-exam/:examId",
    navbarShow: false,
    element: LiveExam,
    name: "Exam",
    icon: faBook,
  },
  {
    path: "exam/:examId",
    navbarShow: false,
    element: SelectedExam,
    name: "Selected-Exam",
  },
  {
    path: "exam/:examId/result",
    navbarShow: false,
    element: ResultIndex,
    name: "Exam-result",
  },
  {
    path: "exam/:examId/result/:userId",
    navbarShow: false,
    element: StudentResult,
    name: "Result-Selected-Student",
  },
  {
    path: "exam/getExamQuestions/:examId",
    navbarShow: false,
    element: ExamQuestionIndex,
    name: "Exam Questions",
  },
  {
    path: "exam/:examId/questions/:questionId",
    navbarShow: false,
    element: QuestionDetails,
    name: "add question details",
    icon: faCircleQuestion,
  },
  {
    path: "exam/addQuestions/:Id",
    navbarShow: false,
    element: AddQuestion,
    name: "add question by id",
    icon: faCircleQuestion,
  },
  {
    path: "logs/:examId",
    navbarShow: true,
    element: LogsIndex,
    name: "Logs",
    icon: faCircleQuestion,
  },
  {
    path: "responses/:examId",
    navbarShow: false,
    element: ResponsesIndex,
    name: "Responses",
    icon: faReplyAll,
  },
  {
    path: "responses/:examId/:mappingId",
    navbarShow: false,
    element: Response,
    name: "Responses",
  },
  {
    path: "exam/:examId/assign-invigilator",
    navbarShow: false,
    element: AssignInvigilatorPage,
    name: "Assign Invigilator",
    icon: faStamp,
  },
  {
    path: "invigilator/view/:invigilatorId",
    navbarShow: false,
    element: ViewInvigilatorPage,
    name: "View Invigilator",
    icon: faUserShield,
  },

  {
    path: "assign-students/:invigilatorId",
    navbarShow: false,
    element: AssignStudentsPage,
    name: "Assign Students",
    icon: faUsers,
  },
];

export default adminRoutes;
